import { useUserProfile } from "@/hooks/useUserProfile";
import { useLocation } from "react-router-dom";
import { usePublicPaths } from "@/hooks/usePublicPaths";

export type UserType = 'unknown' | 'normal' | 'admin';

/**
 * Determines the user's type (normal, admin) based on profile data.
 * Used for permission checks throughout the application.
 */
export const useUserType = () => {
  const location = useLocation();
  const isPublicPath = usePublicPaths();
  const isPublic = isPublicPath(location.pathname);

  const {
    data: profile,
    isLoading,
    error
  } = useUserProfile();

  if (isPublic && !profile) {
    return {
      userType: 'unknown' as UserType,
      isAdmin: false,
      isLoading: false,
      error: null
    };
  }

  if (isLoading) {
    return {
      userType: 'unknown' as UserType,
      isAdmin: false,
      isLoading: true,
      error: null
    };
  }

  if (error || !profile) {
    return {
      userType: 'unknown' as UserType,
      isAdmin: false,
      isLoading: false,
      error: error || new Error('Profile not found')
    };
  }

  const userType = (profile?.profile_type as UserType) || 'normal';

  return {
    userType,
    isAdmin: userType === 'admin',
    isLoading: false,
    error: null
  };
};
